/**
 * Created by ivo on 26.05.14.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'library/fcse-dropdown/dropdown',
    'library/fcse-util/url',
    'clientComponents/map/mapModal',
    'clientComponents/map/dynamicRegionMap',
    'clientComponents/oldoffer/oldOffer',
    'clientComponents/citymultiselect/cityMultiSelectFilter',
    'library/fcse-flyout/flyout'
],
    function($, _, Object, OptionsMixin, EventDispatcher, Dropdown, Url, MapModal, DynamicRegionMap, OldOffer, CityMultiSelectFilter, Flyout) {
        /**
         * Abstract pseudo class for the creational process of
         * the filter widgets.
         *
         * @constructor
         * @param element
         * @param requestHandler
         * @param {Object} scope
         * @param options
         */
        var ContentNode = function(element, requestHandler, scope, options) {
            EventDispatcher.apply(this, arguments);

            // Store element
            this.element = element;

            // Store group ID for content loading
            this.groupId = $(element).attr('data-group-id');
            this.groupIds = $(element).attr('data-group-id');
            this.filterGroupIds = null;

            // Set default options
            var defaultOptions = {
                openClass: 'is-active',
                closedClass: 'is-closed',
                loadingClass: 'is-loading',
                paramNameId: 'GroupIds',
                groupIds: 'groupIds',
                filterGroupIds: 'filterGroupIds',
                offerItemSelector: '[data-fcse-role="offer-item"]',
                nodeAccordionSelector: '[data-fcse-role="accordion--contentnode"]',
            };
            this.addOptions(defaultOptions, options);

            // Save local variables
            this.requestHandler = requestHandler;
            this.scope = scope;

            this._init();
            // Init event handling
            this._initEventHandling();
        };

        ContentNode.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
            /**
             * Basic initialization
             * @private
             */
            _init: function() {
                // Check if content for this node already exist then initialize it
                if ($(this.option('offerItemSelector'), this.element).length) {
                    this.contentIsLoaded = true;
                    this._initContent();
                }
                $(this.element).data('content-node-instance', this);
            },

            /**
             * Initializes event handlers
             * @private
             */
            _initEventHandling: function(){
                var self = this;
                $('[data-fcse-role="accordion--contentnode--header"]', this.element).click(function(){
                    self.toggle();
                });

                // Content loading events
                this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
            },

            /**
             * Returns true if the node is open
             * @return boolean
             */
            isOpen: function(){
                return $(this.element).hasClass(this.option('openClass'));
            },

            /**
             * Loads the content of the accordion
             * @private
             */
            _loadContent: function(additionalParams){
                this.filterGroupIds = null;
                var params = this.scope.getQuery();
                params = $.extend(params, additionalParams || {});
                params[this.option('groupIds')] = this.groupIds;

                if (typeof params[this.option('groupIds')] === 'undefined') {
                    params[this.option('groupIds')] = this.groupIds;
                }

                if (Array.isArray(params[this.option('groupIds')])) {
                    params[this.option('groupIds')] = params[this.option('groupIds')].join(';');
                }

                if (Array.isArray(params[this.option('filterGroupIds')])) {
                    params[this.option('filterGroupIds')] = params[this.option('filterGroupIds')].join(';');
                    this.filterGroupIds = params[this.option('filterGroupIds')];
                }

                if (typeof params[this.option('filterGroupIds')] === 'undefined') {
                    params[this.option('groupIds')] = this.groupIds;
                }

                this.requestHandler.send(this.option('nodeContentRoute'), params);

                $("html, body").animate({ scrollTop: $(this.element).offset().top}, "fast");
                // Set loading state
                $('[data-fcse-role="accordion--contentnode--body"]', this.element).addClass(this.option('loadingClass'));
            },

            /**
             * Handler for content loading success
             * @param event
             * @param data
             * @private
             */
            _onLoadContentSuccess: function(event, data){
                // Check if ajax response is from nodeContentRoute
                if (data.route === this.option('nodeContentRoute')){
                    // Check if ajax response if for this node
                    if (!this.filterGroupIds) {
                        if (data.queryParams[this.option('groupIds')] !== this.groupIds){
                            return;
                        }
                    } else {
                        if (data.queryParams[this.option('filterGroupIds')] !== this.filterGroupIds){
                            return;
                        }
                    }

                    this._onNodeContentLoad(event, data);
                }
            },

            /**
             * Handle loading node content
             * @param {Object} event
             * @param {Object} data
             */
            _onNodeContentLoad: function(event, data) {
                var contentNode = $('[data-fcse-role="accordion--contentnode--body"]', this.element);
                // Reset loading state
                contentNode.removeClass(this.option('loadingClass'));

                // Replace HTML content
                contentNode.html(event.html);

                this._initContent();

                // Prevent duplicate loading
                this.contentIsLoaded = true;
            },

            /**
             * Click handler for pagination link
             * @param event
             * @private
             */
            _onPaginationClick: function(event){
                // do nothing, if click on the same page
                if ($(event.currentTarget).parent().hasClass('is-active')) {
                    return;
                }
                var page = $(event.currentTarget).attr('data-page');
                if (Math.max($("html").scrollTop(), $("body").scrollTop()) > $(this.element).offset().top){
                    $("html, body").animate({ scrollTop: $(this.element).offset().top - 5}, "fast");
                }

                let filterGroupIds = this.cityMultiSelectFilter.getValue();

                this._loadContent({
                    'sort': this.sortingDropdown.getValue(),
                    'resultsPerPage': this.limitDropdown.getValue(),
                    'page': page,
                    [this.option('filterGroupIds')]: filterGroupIds,
                    [this.option('groupIds')]: this.groupIds
                });
            },

            /**
             * Handler for content loading error
             * @param event
             * @private
             */
            _onLoadContentError: function(event){
                console.log('Error handling');
            },

            /**
             *
             * @private
             */
            _onDropdownChange: function(){
                const filterGroupIdsParamName = this.option('filterGroupIds');
                let filterGroupIds = this.cityMultiSelectFilter.getValue();

                if (!this._isUpdatedFilterGroupIds()
                    && this.limitDropdown.getValue() == this.limitDropdown.prevVal
                    && this.sortingDropdown.getValue() == this.sortingDropdown.prevVal) {
                    return false
                }

                if (this._isUpdatedFilterGroupIds()) {
                    this._updateFilterGroupIds();
                }

                if (filterGroupIds && filterGroupIds.length) {
                    this._loadContent({
                        'sort': this.sortingDropdown.getValue(),
                        'resultsPerPage': this.limitDropdown.getValue(),
                        [filterGroupIdsParamName]: filterGroupIds
                    });
                } else {
                    this._loadContent({
                        'sort': this.sortingDropdown.getValue(),
                        'resultsPerPage': this.limitDropdown.getValue(),
                        [filterGroupIdsParamName]: ''
                    });
                }
            },

            /**
             * Checking, was updated cities?
             * @returns {boolean}
             * @private
             */
            _isUpdatedFilterGroupIds: function() {
                let filterGroupIds = this.cityMultiSelectFilter.getValue();
                let filterGroupIdsPrev = this.cityMultiSelectFilter.prevVal;

                if (
                    filterGroupIds.length === filterGroupIdsPrev.length &&
                    filterGroupIds.toString() === filterGroupIdsPrev.toString()
                ) {
                    return false;
                }

                return true;
            },

            /**
             * Saving filters for one groupId
             *
             * @returns {boolean}
             * @private
             */
            _updateFilterGroupIds: function() {
                const url = new Url(window.location.href)
                const filterGroupIdsParamName = this.option('filterGroupIds');
                let filterGroupIds = this.cityMultiSelectFilter.getValue();
                const groupIdCount = $(this.option('nodeAccordionSelector')).length

                // set filterGroupIds in scope for searchMask if we have one group id
                if (groupIdCount !== 1 ) {
                    return false;
                }

                this.scope.setParam(filterGroupIdsParamName, filterGroupIds);

                // update location
                if (filterGroupIds) {
                    url.query[filterGroupIdsParamName] = filterGroupIds.join(';');
                } else {
                    delete url.query[filterGroupIdsParamName];
                }

                window.history.pushState(this.scope.getParams(), '', window.location.pathname + url.getQuery());
            },

            /**
             * Initialize content elements
             * @private
             */
            _initContent: function(){
                var self = this;
                // Initialize dropdowns
                this.sortingDropdown = new Dropdown($('[data-widget-type="widget-sorting"]', this.element));
                this.sortingDropdown.on('change', $.proxy(this._onDropdownChange, this));
                this.sortingDropdown.prevVal = this.sortingDropdown.getValue();
                this.limitDropdown = new Dropdown($('[data-widget-type="widget-resultsperpage"]', this.element));
                this.limitDropdown.on('change', $.proxy(this._onDropdownChange, this));
                this.limitDropdown.prevVal = this.limitDropdown.getValue();

                this._createCityMultiSelectWidget();
                this.cityMultiSelectFilter.on('change', $.proxy(this._onDropdownChange, this));

                var hotelsButton = $('[data-fcse-role="hotels-map-overlay-open-button"]', this.element);
                var hotelProductSearch = hotelsButton.data('product-search');
                var mapCountryName = $(this.element).attr('data-map-country-name');
                var mapGroupName = hotelsButton.data('id');

                hotelsButton.click(function() {
                    var thisElement = $(this);
                    MapModal.getInstance().open(
                        mapGroupName,
                        hotelProductSearch,
                        thisElement.data('fallback-center'),
                        mapCountryName,
                        'Liste'
                    );
                });

                const dynamicRegionMap = $(this.element).find('[data-fcse-role="dynamic-region-map"]');
                if (dynamicRegionMap.length) {
                    this.dynamicRegionMap = new DynamicRegionMap(dynamicRegionMap, this.requestHandler, {});
                }

                $('[data-fcse-role="hotel-map-overlay-open-button"]', this.element).click(function() {
                    var thisElement = $(this);
                    MapModal.getInstance().open(
                        mapGroupName,
                        hotelProductSearch,
                        thisElement.data('fallback-center'),
                        mapCountryName,
                        'Hotel',
                        thisElement.data('map-hotel-id')
                    );
                });

                // Initialize paging
                $('[data-fcse-role="pagination"] [data-page]', this.element)
                    .off('click')
                    .on('click', $.proxy(this._onPaginationClick, this));

                if ($('[data-fcse-bookingtype="package"]').length) {
                    new OldOffer($(this.element).find('[data-fcse-role="accordion-hotels"]'), self.requestHandler, {
                        oldPriceRoute: 'allt_old_price_offers.price'
                    });
                }
            },

            _createCityMultiSelectWidget: function () {
                var cityMultiSelectFlyout = new Flyout(
                    $('.flyout-city-multi-select-filter', this.element),
                    {
                        closeOnOutsideClick: true,
                        submitOnOutsideClick: true,
                    }
                );
                cityMultiSelectFlyout.setCaptionElement(
                    $('.widget--value', $('.widget-citymultiselect', this.element))
                );
                cityMultiSelectFlyout.bindEventToCallerElement(
                    'click', $('.widget--btn, .widget--value', $('.widget-citymultiselect', this.element))
                );

                var cityMultiSelectFilter = new CityMultiSelectFilter($('.flyout-city-multi-select-checklist', this.element));
                cityMultiSelectFlyout.setWidget(cityMultiSelectFilter);
                this.cityMultiSelectFilter = cityMultiSelectFilter;
                this.cityMultiSelectFilter.prevVal = this.cityMultiSelectFilter.getValue();
            },

            /**
             * Opens the accordion node
             */
            open: function(params) {
                params = params||{};
                $(this.element)
                    .addClass(this.option('openClass'))
                    .removeClass(this.option('closedClass'));

                // Load content if there is none
                if (!this.contentIsLoaded){
                    this._loadContent(params);
                }
            },

            /**
             * Closes the accordion node
             */
            close: function(){
                $(this.element)
                    .removeClass(this.option('openClass'))
                    .addClass(this.option('closedClass'));
            },

            /**
             * Toggles the open state of the accordion node
             */
            toggle: function(){
                if (this.isOpen()){
                    this.close();
                } else {
                    this.open();
                }
            }
        });

        return ContentNode;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/accordion/contentNode.js